<template>
  <b-card>
    <b-row>
      <b-col>
        <b-form-group id="name-gr" label="عنوان:" label-for="name">
          <b-form-input
            id="name"
            v-model="Topic.name"
            required
            placeholder="عنوان"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="code-gr" label="کد:" label-for="code">
          <b-form-input
            id="code"
            v-model="Topic.code"
            required
            placeholder="کد"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          id="mdid95_group-gr"
          label="نوع :"
          label-for="mdid95_group"
        >
          <MDDropdown
            v-bind:group="99"
            v-model="Topic.mdid99_source"
          ></MDDropdown>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          id="mdid95_group-gr"
          label="گروه سرفصل:"
          label-for="mdid95_group"
        >
          <MDDropdown
            v-bind:group="95"
            v-model="Topic.mdid95_group"
          ></MDDropdown>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          id="parent_id-gr"
          label="سرفصل پدر:"
          label-for="parent_id"
        >
          <b-form-select
            v-model="Topic.parent_id"
            :options="list"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group
          id="min_bed-gr"
          label="حداقل بدهکاری:"
          label-for="min_bed"
        >
          <b-form-input
            id="min_bed"
            v-model="Topic.min_bed"
            required
            placeholder
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          id="min_bes-gr"
          label="حداقل بستانکار:"
          label-for="min_bes"
        >
          <b-form-input
            id="min_bes"
            v-model="Topic.min_bes"
            required
            placeholder
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          id="max_bed-gr"
          label="حداکثر بدهکار:"
          label-for="max_bed"
        >
          <b-form-input
            id="max_bed"
            v-model="Topic.max_bed"
            required
            placeholder
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          id="max_bes-gr"
          label="حداکثر بستانکار:"
          label-for="max_bes"
        >
          <b-form-input
            id="max_bes"
            v-model="Topic.max_bes"
            required
            placeholder
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group id="Type-gr" label="انواع تفضیلی:" label-for="Type">
          <MDMulty v-bind:group="94" v-model="Topic.mdid94_types"></MDMulty>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-button variant="success" @click="Save()">ذخیره</b-button>
    </b-row>
  </b-card>
</template>

<script>
import MDDropdown from "../../../components/MDDropdown";
import MDMulty from "../../../components/MDMulty";
import httpHelper from "../../../helpers/httpHelper";
export default {
  name: "AddTopic",
  data() {
    return {
      list: [],
      Topic: {
        name: "",
        code: "",
        mdid95_group: null,
        parent_id: null,
        year_id: 1,
        min_bed: 0,
        min_bes: 0,
        max_bed: 0,
        max_bes: 0,
        fk_id: 0,
        is_from_shepa: false,
        mdid99_source: null,
        mdid94_types: [],
      },
    };
  },
  components: {
    MDDropdown,
    MDMulty,
  },
  created() {
    httpHelper.getData("acctopic").then((res) => {
      this.list = res.result.map((element) => {
        return {
          text: "(" + element.code + ") " + element.name,
          value: element.id,
        };
      });
      if (this.$route.params.id) {
        httpHelper
          .getData("acctopic?id=" + this.$route.params.id)
          .then((res) => {
            if (res.success == true) {
              this.Topic = res.result;
              this.Topic.mdid94_types = [];
              console.log(this.Topic);
            }
          });
      }
    });
  },
  methods: {
    Save() {
      httpHelper.postData("acctopic", this.Topic).then((res) => {
        this.$router.push("/Topics");
      });
    },
  },
};
</script>